var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwnersManualSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3720703,2.5673828c-0.3974609-0.3759766-0.9091797-0.5517578-1.453125-0.5400391 C22.1113281,2.3779297,17.6904297,5.9208984,16,7.5527344C14.3095703,5.9208984,9.8886719,2.3779297,3.0810547,2.0273438 c-0.5341797-0.015625-1.0566406,0.1650391-1.453125,0.5400391C1.2285156,2.9462891,1,3.4785156,1,4.0283203v17.984375 c0,1.0751953,0.8310547,1.9580078,1.8935547,2.0087891c6.6826172,0.3154297,10.5361328,4.1220703,11.5585938,5.28125 C14.8417969,29.7460938,15.40625,30,16,30s1.1582031-0.2539062,1.5478516-0.6972656 c1.0224609-1.1591797,4.8759766-4.9658203,11.5595703-5.28125C30.1689453,23.9707031,31,23.0878906,31,22.0126953V4.0283203 C31,3.4785156,30.7714844,2.9462891,30.3720703,2.5673828z M3,22.0126953L2.9775391,4.0253906 C9.7659912,4.3745728,13.9995117,8.3447266,15,9.388916v17.6175537C13.1074829,25.2340088,9.0949707,22.3104858,3,22.0126953z  M17,26.9587402V9.3881836c1.003418-1.0465698,5.2336426-5.0133667,12-5.3598633v17.984375l0.0126953,0.0107422 C22.9629517,22.3098145,18.9648438,25.182251,17,26.9587402z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnersManualSmall);
export default __webpack_public_path__ + "static/media/owners-manual--small.1a940eabd07bfdfa54e427ad78880dc5.svg";
export { ForwardRef as ReactComponent };